import React, {ReactElement, ReactNode, useEffect} from "react";
import styles from "./FlintLoadingWrapper.module.scss"

export default function FlintLoadingWrapper(props: flintLoadingWrapperProps) {
    const loadingPanelMarkup = (
        <div className={`k-loading-mask ${styles.customLoader}`}>
            <span className="k-loading-text">... loading ...</span>
            {props.showMessage ? <span className={styles.loadingMessage}>
                {props.showMessage}
                {props.showPercent ? <div className={styles.loadingPercentage}>{props.showPercent}%</div> : null}
            </span> 
                : <>{props.showPercent ? <span className={styles.loadingMessage}>
                    <div className={styles.loadingPercentage}>{props.showPercent}%</div></span> : null}</>
            }
            <div className={`k-loading-image ${styles.loadingImage}`}/>
            <div className="k-loading-color"/>
        </div>
    );
    const loadingWrapperClassName = props.loadingWrapperClassName ? `${styles.loadingWrapper} ${props.loadingWrapperClassName}` : `${styles.loadingWrapper}`;
    return (
        <div className={loadingWrapperClassName}>
            {props.children}
            {props.showLoading && loadingPanelMarkup}
        </div>
    )
}

export interface flintLoadingWrapperProps {
    showLoading: boolean;
    showMessage?:string;
    showPercent?:number; // INTEGER
    children: ReactNode;
    loadingWrapperClassName?: string;
}